import {
  AdvancedSearchField,
  AdvancedSearchQualifier,
  fieldsToSearchOptionMap,
  searchOperatorMap,
} from '../constants';

export interface FieldQualifierValue {
  field: AdvancedSearchField;
  qualifier: AdvancedSearchQualifier;
  value: string;
}

const getValueWithAsterisks = ({ qualifier, value }: FieldQualifierValue) =>
  `${qualifier !== AdvancedSearchQualifier.startsWith ? '*' : ''}${value}*`;

const getQueryWithQualifier = ({
  field,
  qualifier,
  value,
  isSpaceSeparated = false,
  customOperator = '',
}: {
  isSpaceSeparated?: boolean;
  customOperator?: string;
} & FieldQualifierValue) => {
  const mappedOperator = customOperator || searchOperatorMap[qualifier];
  const formattedOperator = isSpaceSeparated
    ? ` ${mappedOperator} `
    : mappedOperator;

  return `${fieldsToSearchOptionMap[field]}${formattedOperator}"${value}"`;
};

export const getCqlFieldQualifierValue = ({
  field,
  qualifier,
  value,
}: FieldQualifierValue): string => {
  if (qualifier === AdvancedSearchQualifier.exactPhrase) {
    return getQueryWithQualifier({
      field,
      qualifier,
      value,
    });
  }

  const formattedValue =
    qualifier === AdvancedSearchQualifier.startsWith
      ? getValueWithAsterisks({ qualifier, value, field })
      : value;

  return getQueryWithQualifier({
    field,
    qualifier,
    value: formattedValue,
    isSpaceSeparated: true,
  });
};
